module.exports = {
    methods: {
        _locale() {
            return window._locale;
        },
        /**
         * Translate the given key.
         */
        __(key, replace) {
            let translation,
                translationNotFound = true;

            try {
                translation = key
                    .split(".")
                    .reduce(
                        (t, i) => t[i] || null,
                        window._translations[window._locale].php
                    );

                if (translation) {
                    translationNotFound = false;
                }
            } catch (e) {
                translation = key;
            }

            if (translationNotFound) {
                translation = window._translations[window._locale]["json"][key]
                    ? window._translations[window._locale]["json"][key]
                    : key;
            }

            _.forEach(replace, (value, key) => {
                translation = translation.replace(":" + key, value);
            });

            return translation;
        },
        translate(en_string, mm_string, lang = null) {
            if (lang == null) {
                lang = window._locale;
            }
            if (lang == "mm") {
                return mm_string;
            }

            return en_string;
        },
    },
};
